import { React } from 'react';
import { Container, Stack } from 'react-bootstrap';
import { InterventionList } from './InterventionList/InterventionList';
import { useTranslation } from 'react-i18next';
export function InterventionManagement() {
    const { t } = useTranslation();
    return (
        <Container fluid className="px-5" style={{ maxWidth: '1280px' }}>
            <Stack direction="horizontal" gap={3} className="mt-4 justify-content-between">
                <h2>{t('int.title')}</h2>
            </Stack>
            <InterventionList />
        </Container>
    );
}